import { detailResource } from './detail';
import { listResource } from './list';

const listResources = () => [listResource];

const detailResources = () => [detailResource];

export { listResources, detailResources };
